import { AppRoutePaths, AppRoutes } from "./app-path.routes";

export enum UserTypeEnum {
  internal = "Internal",
  external = "External",
}

export const REGEX_PATTERN = {
  onlyNumberValidator: /^[0-9]*$/,
  onlyAlphaNumericCharacter: /^[a-zA-Z0-9]*$/,
  emailValidator: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  backSlashValidator: /^[a-zA-Z0-9]*(?:\\[a-zA-Z0-9]*)?$/,
};

export enum PriorityEnum {
  Info = "Info",
  Warning = "Warning",
  Critical = "Critical",
}
export enum NotificationAudience {
  internal = "Internal",
  external = "External",
  all = "Internal,External",
}
export enum NotificationPlacement {
  login = "Login",
  dashboard = "Dashboard",
}
export enum FlyoutApplicationEnum {
  applicationList = "Application List",
  addEditApplication = "Add Edit Application",
  notificationList = "Notification List",
}
export enum NotificationStorageEnum {
  home = "home_notifications",
  closeNotification = "close_notifications",
  login = "login_notifications",
}

export enum FooterNameUrlEnum {
  PrivacyPolicy = "https://privacy.paramount.com/en/policy",
  Navigator = "https://navigator.paramount.com/",
  CPSwag = "https://cp.vcomswag.com/",
}
